<div class="manual-root">
    <!-- 上部バー -->
    <header class="manual-topbar">
        <a class="brand" [routerLink]="isPublic ? ['/login'] : ['/kobe/dashboard']">
            <i class="icon-book-open"></i>
            <span>アクティブプロモーション</span>
        </a>
        <span class="topbar-title">{{ title | transloco }}</span>
        <span class="badge" [class.badge-pub]="isPublic">{{ subtitle | transloco }}</span>
        <span class="spacer"></span>
        <button *ngIf="toc.length" class="toc-toggle" type="button" (click)="tocOpen = !tocOpen" [attr.aria-label]="'shell.toc' | transloco">
            <i class="icon-list"></i> {{ 'shell.toc' | transloco }}
        </button>
        <a class="back" [routerLink]="isPublic ? ['/login'] : ['/kobe/dashboard']">
            {{ (isPublic ? 'shell.to_login' : 'shell.back_to_app') | transloco }}
        </a>
    </header>

    <div class="manual-shell">
        <!-- 目次サイドバー -->
        <nav class="manual-toc" [class.open]="tocOpen" *ngIf="toc.length">
            <div class="toc-head">{{ 'shell.toc' | transloco }}</div>
            <ul>
                <li *ngFor="let item of toc" [class.lv3]="item.level === 3">
                    <a href="javascript:void(0)" [class.active]="activeId === item.id"
                       (click)="scrollTo(item.id, $event)">{{ item.text }}</a>
                </li>
            </ul>
        </nav>

        <!-- 本文 -->
        <main class="manual-content">
            <div *ngIf="loading" class="manual-state text-muted">{{ 'shell.loading_ellipsis' | transloco }}</div>
            <div *ngIf="error" class="manual-state text-danger">{{ 'shell.manual_load_failed' | transloco }}</div>
            <article #body class="manual-body" *ngIf="!loading && !error" [innerHTML]="html"></article>
        </main>
    </div>
</div>
